export default __webpack_public_path__ + "static/media/bg-profile@2x.119717f5.jpg";